import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-especiales',
  templateUrl: './especiales.component.html',
  styleUrls: ['./especiales.component.css']
})
export class EspecialesComponent implements OnInit {
  safeUrl: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const acccessToken = this.authService.getToken();

    const iframeUrl = `${environment.ADMIN_URL}dashboard/especiales?token=${acccessToken}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
  }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/especiales/especiales.component.ts